import { Pipe, PipeTransform } from '@angular/core';
import {
    IBookingSearchResultConfig,
    IBookingSearchResultRow
} from "../../interfaces/IConfigurableTable";

@Pipe({
    name: 'findRowByIndex'
})

export class FindRowByIndexPipe implements PipeTransform {
    public transform(index: number, config: IBookingSearchResultConfig): IBookingSearchResultRow {
        return config.rowArray[index];
    }
}
